export default "__VITE_ASSET__1bfe2dfa__"